<div class="bill-detail pl-pane__container--horizontal pl-pane--full-screen">
  <app-nav-bar route="/user/bills"></app-nav-bar>

  <header class="pl-pane__header">
    <div pl-grid="1/1@phone" pl-grid-el>
      <div class="bill-detail__header-row">
        <div class="bill-detail__header-copy">
          <h2 class="pl-heading--xlarge">
            <span [textContent]="'BILL_DETAIL.sale' | translate: { sale_number: bill.sale_number }" ></span>
            <span [class]="statusTagColor(bill)" style="margin-left: 8px">{{ 'SALE_DETAIL.STATUSES.' + bill.display_status | translate }}</span>
          </h2>
          <div>
            <p>
              <span [textContent]="bill.user_full_name"></span>'s
              <span [textContent]="'BILL_DETAIL.SUBTITLE.description' | translate"></span>
              <span [textContent]="bill.store_name"></span>
            </p>
          </div>
        </div>
        <div class="bill-detail__actions">
          <div class="bill-detail__action-buttons">
            <div>
              <se-fe-button seFeDataEmphasis="medium" (click)="printStatement()">
                <span>{{ 'SALE_DETAIL.BUTTONS.print_statement' | translate }}</span>
              </se-fe-button>
            </div>
            @if (canBePaid(bill)) {
              <div>
                <se-fe-button seFeDataEmphasis="high" (click)="makePayment()">
                  <span>{{ 'SALE_DETAIL.BUTTONS.make_a_payment' | translate }}</span>
                </se-fe-button>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </header>

  <section class="pl-pane__info pl-layout--on-gray">
    <div class="pl-centered-container--max-width">
      <div pl-grid="loose">
        <div pl-grid-el pl-grid="1/1@phone 2/3@tablet">
          <div pl-grid="loose">
            <div pl-grid-el pl-grid="1/1@phone">
              <app-sale-info-card
                [sale]="bill"
                [activity]="activity">
              </app-sale-info-card>
            </div>
            @if (payments) {
              <div pl-grid-el pl-grid="1/1@phone">
                <app-payment-plan
                  [sale]="bill"
                  [payments]="payments">
                </app-payment-plan>
              </div>
            }
            <div pl-grid-el pl-grid="1/1@phone">
              @if (activity) {
                <app-sale-activity-card
                  [sale]="bill"
                  [activity]="activity">
                </app-sale-activity-card>
              }
            </div>
          </div>
        </div>
      </div>
      <div pl-grid-el pl-grid="1/1@phone 1/3@tablet">
        @if (bill.parent_sale || bill.child_sales?.length > 0) {
          <se-po-related-orders-card
            [order]="bill"
            [type]="'bill'">
          </se-po-related-orders-card>
        }
      </div>
    </div>
  </section>
</div>

<div #printHost class="bill-detail-print-host">
  <div #printView class="bill-detail-print">
    <section class="bill-detail-print__section">
      <div class="bill-detail-print__content">
        <h1 class="bill-detail-print__title">
          {{ 'BILL_DETAIL.PRINT.title' | translate: { sale_number: bill.sale_number } }}
        </h1>
        @if (bill.store_name) {
          <h2 class="bill-detail-print__subtitle">{{ bill.store_name }}</h2>
        }
        <hr class="bill-detail-print__divider" />

        <div class="bill-detail-print__card">
          <app-sale-info-card [sale]="bill" [activity]="activity"></app-sale-info-card>
        </div>

        @if (hasBillingDetails()) {
          <div class="bill-detail-print__card">
            <se-fe-card>
              <se-fe-card-header
                [seFeDataTitle]="'BILL_DETAIL.PRINT.billing_information' | translate"
                [seFeDataBorder]="true">
              </se-fe-card-header>
              <se-fe-card-content class="bill-detail-print__billing">
                <div class="bill-detail-print__label">
                  {{ 'BILL_DETAIL.PRINT.payment_method' | translate }}
                </div>
                <div>{{ paymentMethodLabel }}</div>
                @if (paymentMethod?.name) {
                  <div class="bill-detail-print__label">
                    {{ 'BILL_DETAIL.PRINT.name_on_card' | translate }}
                  </div>
                  <div>{{ paymentMethod?.name }}</div>
                }
                @if (billingAddressLines.length) {
                  <div class="bill-detail-print__label">
                    {{ 'BILL_DETAIL.PRINT.billing_address' | translate }}
                  </div>
                  @for (line of billingAddressLines; track $index) {
                    <div>{{ line }}</div>
                  }
                }
              </se-fe-card-content>
            </se-fe-card>
          </div>
        }

        @if (payments) {
          <div class="bill-detail-print__card">
            <app-payment-plan [sale]="bill" [payments]="payments"></app-payment-plan>
          </div>
        }

        @if (activity) {
          <div class="bill-detail-print__card">
            <se-fe-card>
              <se-fe-card-header
                [seFeDataTitle]="'SALE_DETAIL.ACTIVITY.activity' | translate"
                [seFeDataBorder]="true">
                <div seFeCardHeaderActions>
                  {{ 'SALE_DETAIL.ACTIVITY.activity_card_data_highlight' | translate: {
                    amountOutstanding: bill.amount_outstanding | displayCurrency:bill.currency_symbol
                  } }}
                </div>
              </se-fe-card-header>
              <se-fe-card-content>
                <table class="bill-detail-print__activity-table">
                  <thead>
                    <tr>
                      <th>{{ 'SALE_DETAIL.LABELS.date' | translate }}</th>
                      <th>{{ 'SALE_DETAIL.LABELS.activity' | translate }}</th>
                      @if (hasTransactions()) {
                        <th>{{ 'SALE_DETAIL.LABELS.transaction' | translate }}</th>
                      }
                      @if (hasActivityNotes()) {
                        <th>{{ 'SALE_DETAIL.LABELS.notes' | translate }}</th>
                      }
                      <th class="bill-detail-print__numeric">{{ 'SALE_DETAIL.LABELS.amount' | translate }}</th>
                      <th class="bill-detail-print__numeric">{{ 'SALE_DETAIL.LABELS.balance' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (item of activity; track $index) {
                      <tr>
                        <td>{{ formatActivityDate(item.created_at) }}</td>
                        <td>{{ item.label }}</td>
                        @if (hasTransactions()) {
                          <td>{{ item.sale_transaction_id ?? '' }}</td>
                        }
                        @if (hasActivityNotes()) {
                          <td>{{ item.notes ?? '' }}</td>
                        }
                        <td class="bill-detail-print__numeric">
                          {{ item.amount | displayCurrency:bill.currency_symbol }}
                        </td>
                        <td class="bill-detail-print__numeric">
                          {{ item.amount_outstanding | displayCurrency:bill.currency_symbol }}
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </se-fe-card-content>
            </se-fe-card>
          </div>
        }
      </div>
    </section>
  </div>
</div>
